import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {Card, Spinner} from "reactstrap";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import { useVsiAppContext } from "../../../stores/VsiApp";
import { virtualOrphansVMDKsDefs } from "../../../utils/gridColumnDefs/virtual/virtualUnits";
import Grid from "../../../components/Grid";
import { getReport } from "../../../utils/Verbs";
import {useTitleFromComponent} from "../../../utils/hooks";

export default function VirtualOrphanedVMDKs({ context, title }) {

    useTitleFromComponent(`${context} / ${title}`);
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const { theme, client, periodId, user, getAccessTokenSilently } = useVsiAppContext();
    
    const [virtualAlerts, setVirtualAlerts] = useState([]);

    const getRouteForAlerts = async () => {
        try {
            const route = `/api/v6/report/virtual_orphaned_vmdks_proc?client_id=${client.clientId}&period_id=${periodId}`;
            const token = await getAccessTokenSilently();
            const data = await getReport(route, null, token);
            const dataGrid = data?.data.recordsets;
            if (client.serviceNowInstance !== null && client.serviceNowInstance.length > 1) {
                dataGrid[0]?.forEach(d => {
                    d['serviceNowInstance'] = client.serviceNowInstance;
                    d['serviceNowUser'] = client.serviceNowUser;
                    d['serviceNowPassword'] = client.serviceNowPassword;
                });
                dataGrid[1]?.forEach(d => {
                    d['serviceNowInstance'] = client.serviceNowInstance;
                    d['serviceNowUser'] = client.serviceNowUser;
                    d['serviceNowPassword'] = client.serviceNowPassword;
                });
            }
            getVirtualAlerts(dataGrid);
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    const getVirtualAlerts = (dataGrid) => {
        setVirtualAlerts(dataGrid[0]);
        setIsLoading(false);
    };
  
    // Runs on load and when period ID is changed
    useEffect(() => {
        getRouteForAlerts();
    }, [client, searchParams.get("period_id")]);


    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>{`Virtual Orphaned VMDKs`}</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> : (
                <VsiBubble>
                    <Grid
                        data={virtualAlerts}
                        columnDefs={virtualOrphansVMDKsDefs}
                        rowSelection={"multiple"}
                        type={"virtual"}/>
                </VsiBubble>
            )}
        </Card>
    );
}
